import { Reminder } from "../entities/reminder.model";
import { UiFieldMessageProps } from "./field-message.model";

export enum ModalReminderMode {
	CREATE = "CREATE",
	UPDATE = "UPDATE",
}

export interface UiModalReminderProps {
	mode: ModalReminderMode;
	entity: Partial<Reminder> | null;
	isVisible: boolean;
	onComplete: (refresh: boolean, reminder: Reminder | null) => void;
	onCancel: () => void;
}

export interface ModalReminderFormProps extends Omit<UiModalReminderProps, "isVisible"> {}

export interface ModalReminderDeleteProps {
	entity: Reminder;
	onComplete: () => void;
	onCancel: () => void;
}

export type ModalReminderData = {
	// Control variables
	formMessage?: UiFieldMessageProps;
	mode: ModalReminderMode;
	// Form fields
	kannactId: string | null;
	patientId: number | null;
	reason: string | null;
	dateOn: Date | null;
	assignedTo: number | null;
	snoozeValue: number | null;
};
